import { BannerVariant } from '../types/Banner.types';

export const DEFAULT_ERROR_TITLE = 'Ein Fehler ist aufgetreten.';
export const DEFAULT_ERROR_DESCRIPTION =
  'Versuchen Sie es später nochmal, oder wenden Sie sich an den Support';

export const DEFAULT_AUTO_HIDE_DURATION = 4000;
export const DEFAULT_BANNER_TYPE = BannerVariant.Error;
export const DEFAULT_DISABLE_CLOSE = false;
